import { Injectable } from "@angular/core";
import { databases, ID } from "../config/appwrite";
import { environment } from "../../../environments/environment";
import { Query } from "appwrite";
import { Sede } from "../models";

@Injectable({
  providedIn: "root",
})
export class SedeService {
  private collectionId = "sedes";
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  /**
   *getSedes
   * @returns
   */
  getSedes() {
    return databases.listDocuments(this.DATABASE_NAME, this.collectionId, [
      Query.equal("activo", true),
    ]);
  }

  /**
   *
   * @returns
   */
  getDataActive(): Promise<Sede[]> {
    return databases
      .listDocuments<Sede>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("activo", true),
      ])
      .then((response) => response.documents);
  }

  /**
   *getSedes
   * @returns
   */
  getData(): Promise<Sede[]> {
    return databases
      .listDocuments<Sede>(this.DATABASE_NAME, this.collectionId)
      .then((response) => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: any) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }

  updateDocument(idSede: string, data: any) {
    data.$databaseId = undefined;
    data.$collectionId = undefined;
    return databases.updateDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idSede,
      data
    );
  }

  getDocument(idDocument: string) {
    return databases.getDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idDocument
    );
  }
}
